import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontPlayfairDisplay, fontRoboto, theme } from "shared/lib/styles";

import { Tooltip, tooltipClasses } from "scmp-app/components/common/tooltip";
import type { ContentHeadlineVariant } from "scmp-app/components/content/content-headline";

export const StyledTooltip = styled(Tooltip)`
  & .${tooltipClasses.tooltip} {
    padding: 20px;

    color: #222222;

    border: 1px solid #cccccc;
    border-radius: 4px;

    background-color: #f6f6f6;
  }

  & .${tooltipClasses.arrow} {
    color: #f6f6f6;
    font-size: 20px;
    &::before {
      border: 1px solid #cccccc;
    }
  }
`;

export const Heading = styled.span`
  display: inline;

  padding-inline-end: 10px;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
`;

export const Description = styled.span`
  display: inline;

  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
`;

export const FlagDivider = styled.span``;

type FlagProps = {
  $color?: string;
  $variant?: ContentHeadlineVariant;
};

export const Flag = styled.span<FlagProps>`
  color: ${props => props.$color ?? "#666666"};

  ${props =>
    props.$variant === "generic" &&
    css`
      inline-size: fit-content;

      color: ${props.$color === "#2aa191" ? "#2aa191" : "#727272"};
      font-weight: 700;
      font-size: 16px;
      font-style: italic;
      line-height: 22.4px;

      ${theme.breakpoints.up("tablet")} {
        font-size: 22px;
        line-height: 30.8px;
      }
    `}

  ${props =>
    props.$variant === "magazines-style" &&
    css`
      color: #222222;
      font-family: ${fontPlayfairDisplay};
      text-transform: uppercase;

      span {
        font-style: italic;
      }

      ${FlagDivider} {
        font-style: normal;
      }
    `}
`;
